import {
  CrudRepository,
  ModelBaseStructure,
  RepositoryFindFielters,
  RepositoryOrderBy,
  Where
} from '@infrab4a/connect';
import { PageableFilter } from 'src/app/admin-api';
import { ConnectRequest, NullValue } from 'src/app/models';
import { OperatorMapper } from '../../enums/OperatorMapper';

export class BaseConnectService<T extends ModelBaseStructure> {
  static NULL = { action: 'null' } as any;
  static REMOVE = { action: 'remove' } as any;

  constructor(private repository: CrudRepository<T>) {}

  async paginatedSearch(request: Partial<ConnectRequest>) {
    const {
      filters: pageableFilter,
      fields,
      page,
      pageSize,
      sortBy,
      sortDirection
    } = request;
    const filters = this.getFiltersQuery(pageableFilter);
    const result = await this.repository.find({
      ...((fields && { fields }) as any),
      ...(filters && { filters }),
      ...(pageSize && {
        limits: {
          limit: pageSize,
          offset: page * pageSize
        }
      }),
      ...(sortBy && {
        orderBy: { [sortBy]: sortDirection } as RepositoryOrderBy<T>
      }),
      options: {
        enableCount: true
      }
    });
    // let count = result.count;
    // if (result.count === Infinity)
    //   count =
    //     (
    //       await this.repository.find({
    //         ...(filters && { filters }),
    //         fields: [],
    //         limits: {
    //           limit: 10000
    //         }
    //       })
    //     ).data?.length || Infinity;
    return result;
  }

  getFiltersQuery(filters: Array<PageableFilter>) {
    if (!filters || !filters.length) return undefined;
    return filters
      .filter(
        (f) =>
          f.value !== undefined &&
          f.value !== '' &&
          (!Array.isArray(f.value) || f.value.some((c) => c))
      )
      .reduce((acc, filter) => {
        let bindedFilter;

        if (filter.condition === 'between' && this.scheme === 'firebase')
          return acc;
        else if (filter.condition === 'between') {
          bindedFilter = [
            {
              value: (filter.value[0] as Date).toISOString(),
              operator: OperatorMapper.gte
            },
            {
              value: (filter.value[1] as Date).toISOString(),
              operator: OperatorMapper.lte
            }
          ];
        } else if (
          filter.value === undefined ||
          filter.value === null ||
          filter.value === '' ||
          (Array.isArray(filter.value) && filter.value[0] == '')
        )
          return acc;
        else if (filter.value === NullValue) {
          bindedFilter = {
            value: null,
            operator:
              filter.condition === 'notEquals' ? Where.ISNOTNULL : Where.ISNULL
          };
        } else if (filter.condition === 'contains') {
          bindedFilter = {
            value: `${filter.value}`,
            operator: OperatorMapper[filter.condition],
            ignoreCase: true,
            ignoreAccent: true
          };
        } else {
          bindedFilter = {
            value:
              filter.fieldType === 'date' &&
              filter.value instanceof Date &&
              this.scheme === 'firebase'
                ? filter.value.getTime()
                : filter.value,
            operator: OperatorMapper[filter.condition]
          };
        }

        if (this.scheme === 'hasura') {
          const splitField = filter.field.split('.');

          acc = {
            ...acc,
            ...splitField
              .reverse()
              .reduce((acc, field) => ({ [field]: acc }), bindedFilter)
          };
        } else {
          acc[filter.field] = bindedFilter;
        }

        return acc;
      }, {} as RepositoryFindFielters<T>);
  }

  get scheme(): 'firebase' | 'hasura' {
    return 'firebase';
  }
}
